import { Element } from "react-scroll";
import React, { useEffect } from "react";
import "./Home.css";
import "../../global/main.css";
import "aos/dist/aos.css";
import logo from "../../image/1Ysr-R03-0VI-Logo (2).png";
import image1 from "../../image/أبراج.png";
import image2 from "../../image/دوائر.png";
import Aos from "aos";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const Home = (props) => {
  const isMobile = props.isMobile || false;

  useEffect(() => {
    Aos.init({
      duration: 500,
      once: true,
      disable: isMobile ? false : "mobile",
    });
  }, [isMobile]);

  return (
    <Element name="Home">
      <section className="Home">
        <div className="Home-body">
          <div
            className="home-right"
            data-aos="fade-down"
            data-aos-easing="linear"
            data-aos-duration="1500"
          >
            {logo ? (
              <img src={logo} alt="Company Logo" className="home-logo" />
            ) : (
              <Skeleton height={100} width={200} />
            )}
            <p className="home-slogan">
              "نُمَهِّد لك
              <span className="highlight">الطريق الصحيح </span> بوجهةٍ ثابتة"
            </p>
          </div>

          <div
            className="home-left"
            data-aos="fade-up"
            data-aos-easing="linear"
            data-aos-duration="1500"
          >
            {image1 ? (
              <img
                src={image1}
                alt="Towers"
                className="home-towers"
                style={{
                  transform: `scale(${props.scale})`,
                  transformOrigin: "center bottom",
                }}
              />
            ) : (
              <Skeleton height={300} width={300} />
            )}

            {image2 && (
              <img
                src={image2}
                alt="Circles"
                className="home-circles"
                data-aos="zoom-in"
                data-aos-easing="ease-in-sine"
                data-aos-duration="2000"
              />
            )}
          </div>
        </div>
      </section>
    </Element>
  );
};

export default Home;


